import { PROJECT_TOGGLE } from "../constants/projectConstants";

export const toggleProject = (projectName) => {
  return (dispatch) => {
    dispatch({ type: PROJECT_TOGGLE, payload: projectName });
  };
};
